import { isAndroidApp } from "@/lib/twa";

// Air Wave Android package (confirmed by owner).
export const PLAY_STORE_ID = "net.airwavestream.app";
export const PLAY_STORE_WEB = `https://play.google.com/store/apps/details?id=${PLAY_STORE_ID}`;
export const PLAY_STORE_SEARCH = "https://play.google.com/store/search?q=Air%20Wave%20Stream&c=apps";

// Flip to true once the app is LIVE on the Play Store under PLAY_STORE_ID.
// Until then we collect ratings in-app (never send users to a dead store link).
export const PLAY_STORE_PUBLISHED = true;

const RATE_DONE = "aw_rate_done";
const OPEN_COUNT = "aw_open_count";
const ASK_AT = 3; // prompt on the 3rd meaningful open

export function openRate() {
  const web = PLAY_STORE_PUBLISHED ? PLAY_STORE_WEB : PLAY_STORE_SEARCH;
  try { localStorage.setItem(RATE_DONE, "1"); } catch (_) {}
  if (isAndroidApp() && PLAY_STORE_PUBLISHED) {
    window.location.href = `market://details?id=${PLAY_STORE_ID}`;
    setTimeout(() => window.open(web, "_blank", "noopener"), 500);
  } else {
    window.open(web, "_blank", "noopener");
  }
}

export function hasRated() {
  try { return localStorage.getItem(RATE_DONE) === "1"; } catch (_) { return false; }
}

export function markRateDone() {
  try { localStorage.setItem(RATE_DONE, "1"); } catch (_) {}
}

// Increments the app-open counter once per browser session; returns whether
// we should now show the rating prompt (>= ASK_AT opens and not already rated).
export function shouldPromptRating() {
  try {
    if (hasRated()) return false;
    if (sessionStorage.getItem("aw_open_counted") !== "1") {
      const n = (parseInt(localStorage.getItem(OPEN_COUNT) || "0", 10) || 0) + 1;
      localStorage.setItem(OPEN_COUNT, String(n));
      sessionStorage.setItem("aw_open_counted", "1");
    }
    const count = parseInt(localStorage.getItem(OPEN_COUNT) || "0", 10) || 0;
    return count >= ASK_AT;
  } catch (_) {
    return false;
  }
}

export function snoozeRating() {
  try { localStorage.setItem(OPEN_COUNT, "0"); sessionStorage.setItem("aw_open_counted", "1"); } catch (_) {}
}
